import React, { useState } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import ReactHtmlParser from 'react-html-parser'
import get from 'lodash/get'
import groupBy from 'lodash/groupBy'
import map from 'lodash/map'

import { formatDateLocalized, useLanguage } from '../utils'
import { WithScroller } from '../WithScroller'

export type RatingsHistoryProps = {
  ratingId: string
  ratingEffectiveDate: string
  ratingCode: string
  ratingAlertCode: string
  ratingActionDescription: string
  ratingTypeDescription: string
  recoveryRatingValue: string
  correctionFlag: boolean
  changeDate: string
  ratingActionReasonDescription: string
  ratingActionReasonID: string
}

export type RatingsHistoryRowProps = {
  ratablesRatingHistory?: any[]
  children?: any
  row?: any
}

export type RatingsHistoryItemProps = {
  items: RatingsHistoryProps[]
}

const TableCell = (language: string | undefined, item: RatingsHistoryProps) => {
  const {
    ratingActionReasonID,
    ratingActionReasonDescription,
    ratingId,
    ratingEffectiveDate,
    correctionFlag,
    changeDate,
    ratingCode,
    ratingAlertCode
  } = item
  let { ratingActionDescription: ratableActionDescription } = item
  if (ratingActionReasonID === '345' && ratingActionReasonDescription) {
    ratableActionDescription += ` - ${ratingActionReasonDescription}`
  }

  return (
    <td style={{ verticalAlign: 'top' }} key={ratingId}>
      {formatDateLocalized(ratingEffectiveDate, 'MMM dd yyyy', language)}
      <br />
      {ratingCode}
      {ReactHtmlParser(
        ratingAlertCode
          ? `<span class=frw-${ratingAlertCode.replace(':', '')}></span>`
          : ''
      )}
      <br />
      {ratableActionDescription}
      {correctionFlag
        ? ReactHtmlParser(
            `<br />Rating Correction
            <br />
            (${formatDateLocalized(changeDate, 'MMM dd yyyy', language)})`
          )
        : null}
    </td>
  )
}
export const RatingsHistory = (props: RatingsHistoryRowProps) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0)
  const { language } = useLanguage()

  const handleTabSelection = (tabIndex: number) => {
    setSelectedTabIndex(tabIndex)
  }
  const { children, ratablesRatingHistory = [], row = {} } = props
  const { original } = row
  const rowOriginaldata = original ? original.ratablesRatingHistory : []
  const ratablesRatingHistoryData =
    ratablesRatingHistory && ratablesRatingHistory.length
      ? ratablesRatingHistory
      : rowOriginaldata

  const groupedByRatingTypeDescription = map(
    groupBy(ratablesRatingHistoryData, 'ratingTypeDescription'),
    (value, key) => ({ ratingTypeDescription: key, ratings: value })
  )

  const tabs: any[] = []
  const tabPanels: any[] = []
  groupedByRatingTypeDescription.forEach((ratingTypeDescription) => {
    tabs.push(
      <Tab key={ratingTypeDescription.ratingTypeDescription}>
        {ratingTypeDescription.ratingTypeDescription}
      </Tab>
    )
    const ratings: RatingsHistoryProps[] = get(
      ratingTypeDescription,
      'ratings',
      []
    )

    tabPanels.push(
      <TabPanel key={ratingTypeDescription.ratingTypeDescription}>
        <div className="frw-table frw-table--2">
          <div className="frw-table__overflow">
            <WithScroller>
              <table
                className="frw-table__wrapper"
                style={{ width: '100%', minWidth: 'auto' }}
              >
                <tbody>
                  <tr>
                    {children ? (
                      <td style={{ verticalAlign: 'top' }}>{children}</td>
                    ) : null}
                    {ratings.map((item) => TableCell(language, item))}
                  </tr>
                </tbody>
              </table>
            </WithScroller>
          </div>
        </div>
      </TabPanel>
    )
  })
  return (
    <Tabs
      selectedTabClassName={
        tabs.length === 1 ? 'react-tabs__tab--heading' : ''
      }
      selectedIndex={selectedTabIndex}
      onSelect={(index) => handleTabSelection(index)}
    >
      <WithScroller>
        <TabList>{tabs}</TabList>
      </WithScroller>
      {tabPanels}
    </Tabs>
  )
}
